<template>
  <div class="tab-breadcrumb">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item><i class="el-icon-terminal iconfont" style="font-size: 12px;"></i></el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t(breadcrumbKey) || breadcrumbName }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { defineComponent, nextTick, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, onBeforeRouteUpdate } from 'vue-router'
import { $t } from '@/lang'

export default defineComponent({
  name: 'ContainerTabBreadcrumb',
  setup () {
    const store = useStore()
    const route = useRoute()
    const breadcrumbKey = ref('')
    const breadcrumbName = ref('')
    const breadcrumbRoute = ref('')

    const pageList = store.state.menu.pageList

    const setBreadcrumb = (routeLink) => {
      const currentRoute = routeLink || route.path
      const currentPage = pageList.find(item => item.route === currentRoute)
      if (currentPage) {
        breadcrumbKey.value = currentPage.localKey || ''
        breadcrumbName.value = currentPage.name || ''
        breadcrumbRoute.value = currentPage.route
      }
    }
    setBreadcrumb()

    onBeforeRouteUpdate((updateGuard) => {
      setBreadcrumb(updateGuard.path)
    })

    return {
      $t,
      breadcrumbKey,
      breadcrumbName,
      breadcrumbRoute
    }
  }
})
</script>

<style lang='scss' scoped>
.tab-breadcrumb {
  white-space: nowrap;
  margin-left: 145px;
  margin-right: 16px;

  .el-breadcrumb {
    display: flex;
    font-size: 12px;
  }
}
</style>
